<template>
  <el-dialog
    title="车辆结算"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="入场编号" prop="RegistrationNum">
            <el-input
              v-model="form.RegistrationNum"
              placeholder="入场编号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号" prop="LicensePlate">
            <el-input
              v-model="form.LicensePlate"
              placeholder="车牌号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆类型" prop="VehicleType">
            <DataDic v-model="form.VehicleType" type="VehicleType"></DataDic>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收车时间" prop="RegistrationDate">
            <el-input
              v-model="form.RegistrationDate"
              placeholder="收车时间"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="毛重（kg）" prop="GrossWeight">
            <el-input
              v-model="form.GrossWeight"
              placeholder="毛重（kg）"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="皮重（kg）" prop="TareWeight">
            <el-input
              v-model="form.TareWeight"
              placeholder="皮重（kg）"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="净重（kg）" prop="CarWeigh">
            <el-input
              v-model="form.CarWeigh"
              placeholder="净重（kg）"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扣杂（kg）" prop="BuckleWeight">
            <el-input
              v-model="form.BuckleWeight"
              placeholder="扣杂重量（kg）"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="铝圈个数" prop="AluminumRingNum">
            <el-input
              v-model="form.AluminumRingNum"
              placeholder="铝圈个数"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送达方式" prop="DeliveryMethod">
            <el-input
              v-model="form.DeliveryMethod"
              placeholder="送达方式"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扣杂费用" prop="MiscellaneousExpenses">
            <el-input
              v-model="form.MiscellaneousExpenses"
              placeholder="扣杂费用"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="附加费用" prop="Surcharge">
            <el-input
              v-model="form.Surcharge"
              placeholder="附加费用"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单价" prop="UnitPrice">
            <el-input
              v-model="form.UnitPrice"
              placeholder="单价（元/kg）"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结算价" prop="SettlementPrice">
            <el-input
              v-model="form.SettlementPrice"
              placeholder="结算价"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 按钮 -->
    <span slot="footer">
      <el-button type="primary" :loading="loading" @click="save"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      visible: false,
      loading: false,
      form: {},
      rules: {
        MiscellaneousExpenses: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
        Surcharge: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
        UnitPrice: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
        SettlementPrice: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
      },
    };
  },
  watch: {
    item: {
      handler: function (v) {
        this.$get("VehicleRegistration/GetSettlementModel", {
          RegistId: v.KeyId,
        }).then((r) => {
          this.init({ ...r.Result });
        });
        this.activeNames = "1";
        this.visible = true;
      },
    },
  },
  // methods方法
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let params = { ...this.form };

        this.loading = true;
        this.$post("VehicleRegistration/AddSettlement", params).then((r) => {
          this.$message.success("添加成功");
          this.visible = false;
          this.$emit("success");
        });
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
